const profile = [
  {
    id: 1,
    photo: "./andi.png",
    nama: "Andi Paris Bachtiar",
    text: "Never stop learning because that's what will push you to keep moving forward and be better",
    socialMedia: "https://www.linkedin.com/in/andi-paris-b-871960141/"
  },
  {
    id: 2,
    photo: "./azmiy.png",
    nama: "Azmiy Thuffail",
    text: "Do something today that your future self will thank you for.",
    socialMedia: "https://www.linkedin.com/in/azmiy-thufail/"
  },
  {
    id: 3,
    photo: "./dicky.png",
    nama: "Dicky Firmansyah",
    text: "It does not matter how slowly you go as long as you do not stop.",
    socialMedia: "https://www.linkedin.com/in/dicky-firmansyah-ekadiputra-71001b22b/"
  },
  {
    id: 4,
    photo: "./naufal.png",
    nama: "Naufal Anas",
    text: "If you want live a happy life, tie it to a goal, not to people or things.",
    socialMedia: "https://www.linkedin.com/in/naufal-anas-3b2333204/"
  }
];

export default profile;